export enum PRICE_LIST_ITEM_FORM_TYPE {
  EDIT = 'EDIT',
  NEW = 'NEW',
}

/**
 * Backend blokuje mazání položky navázané na výdejní sadu — vrací 400 s polem
 * chyb, kde je tento kód. Text hlášky si drží frontend, aby fungoval i v sk.
 */
export const PRICE_LIST_ITEM_IN_USE_CODE = 'vydej_price_list_item_in_use';
